import React from 'react';
import PropTypes from 'prop-types';
import Tabs from './Tabs.jsx'
import Tab from './Tab.jsx'
import RadioboxRatesFilter from './RadioboxRatesFilter.jsx'
import CheckboxRatesFilter from './CheckboxRatesFilter.jsx'
import DateRangeRatesFilter from './DateRangeRatesFilter.jsx'
import { List } from 'immutable';
import { getCriteriaDisplayOrder } from '../../Business/RatesSearch';

function criterionHasTwoOrMoreOptions(filterCriterion, options) {
    const filterOptions = options.get(filterCriterion.key);
    return filterOptions.size >= 2;
}

class RatesFiltersWithTabsView extends React.Component {
    render() {
        const filterCriteria = getCriteriaDisplayOrder();
        const isDateRangeFilter = (key) => key == "effectiveDates";
        const isOwnerFilter = key => key == "owners";
        const displayableFilterCriteria = filterCriteria.filter(fc =>
            isDateRangeFilter(fc.key) || criterionHasTwoOrMoreOptions(fc, this.props.options)
        );
        const tabs = displayableFilterCriteria.map((filterCriterion) => {
            const key = filterCriterion.key;
            let optionalProperties = {};
            if ((!isOwnerFilter(key) && !isDateRangeFilter(key) )) {
                optionalProperties.category = key;
            }

            return (
                <Tab key= { key } title={ filterCriterion.label } { ...optionalProperties }>
                    { isDateRangeFilter(key)
                        ? <DateRangeRatesFilter
                            category={ key }
                            value = { this.props.searchCriteria.get(key) }
                            onChange={ this.onSelectedValuesChange }
                        />
                        : null
                    }
                    { isOwnerFilter(key)
                        ? <RadioboxRatesFilter
                            category={ key }
                            options={ this.props.options.get(key) }
                            selectedOptions={ this.props.searchCriteria.getIn([key]) }
                            onChange={ this.onOwnerChange }
                            changeMessage={"Filters have been updated and reset to reflect the rate cards associated with the newly selected owner."}
                        />
                        : null
                    }
                    { (!isOwnerFilter(key) && !isDateRangeFilter(key) )
                        ? <CheckboxRatesFilter
                            category={ key }
                            options={ this.props.options.get(key) }
                            selectedOptions={ this.props.searchCriteria.getIn([key]) }
                            searchText={ this.props.searchCriteria.getIn(['searchText', key]) }
                            onSelectedValuesChange={ this.onSelectedValuesChange }
                            onSearchTextChange={ this.onSearchTextChange }
                        />
                        : null
                    }
                </Tab>)
        });
        return (
            <Tabs onTabClick={ this.onTabClick } >
                { tabs }
            </Tabs>
        );
    }

    onTabClick = (category) => {
        this.onSearchTextChange(category, '');
    }

    onOwnerChange = (category, newSelectedValues) => {
        this.onSelectedValuesChange(category, newSelectedValues);

        const ownerId = newSelectedValues[0].get('id');
        this.props.onOwnerFilterChange(ownerId);
    }

    onSelectedValuesChange = (category, newSelectedValues) => {
        const categoryObjectWithNewValues = this.props.searchCriteria.set(category, newSelectedValues);
        this.props.onSearchCriteriaChange(categoryObjectWithNewValues);
    }

    onSearchTextChange = (category, newSearchText) => {
        const categoryObjectWithNewSearchText = this.props.searchCriteria.setIn(['searchText', category], newSearchText);
        this.props.onSearchCriteriaChange(categoryObjectWithNewSearchText);
    }

    static propTypes = {
        options: PropTypes.object.isRequired,
        searchCriteria: PropTypes.object.isRequired,
        onSearchCriteriaChange: PropTypes.func.isRequired, // onChange(newSelection: Immutable<{ ... { id, name} }> | [startDate, endDate])
        onOwnerFilterChange: PropTypes.func.isRequired // onChange(ownerId)
    }
}

export default RatesFiltersWithTabsView;
